var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdnoklassniki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3315_16797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 20.488C24 22.4276 22.4356 24 20.5058 24H3.4941C1.56434 24 0 22.4276 0 20.488V3.51202C0 1.57237 1.56441 0 3.4941 0H20.5058C22.4356 0 24 1.57243 24 3.51202V20.488Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9865 3.49963C9.5832 3.49963 7.63501 5.45788 7.63501 7.87342C7.63501 10.289 9.5832 12.2474 11.9865 12.2474C14.3897 12.2474 16.3379 10.289 16.3379 7.87342C16.3379 5.45788 14.3897 3.49963 11.9865 3.49963ZM11.9865 9.68157C10.993 9.68157 10.1877 8.87201 10.1877 7.87348C10.1877 6.87496 10.993 6.06546 11.9865 6.06546C12.9799 6.06546 13.7853 6.87496 13.7853 7.87348C13.7853 8.87201 12.9799 9.68157 11.9865 9.68157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5227 15.7276C15.2648 15.3708 16.3087 14.5416 16.364 14.4971C16.8737 14.0862 16.9556 13.3377 16.5468 12.8253C16.138 12.3129 15.3934 12.2306 14.8836 12.6415C14.8728 12.6502 13.7594 13.5087 11.9274 13.51C10.0954 13.5087 8.95848 12.6502 8.9477 12.6415C8.43782 12.2306 7.69323 12.3129 7.28447 12.8253C6.87565 13.3377 6.95754 14.0862 7.4673 14.4971C7.52329 14.5423 8.61031 15.3931 10.4012 15.7414L7.90527 18.3632C7.45167 18.8361 7.46531 19.5889 7.93572 20.0448C8.16531 20.2673 8.46123 20.3779 8.7569 20.3779C9.06689 20.3779 9.37657 20.2562 9.60872 20.0142L11.9274 17.5315L14.4804 20.0302C14.9429 20.4944 15.6919 20.4937 16.1536 20.0289C16.6153 19.5641 16.6147 18.8111 16.1523 18.3471L13.5227 15.7276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9274 13.5099C11.9243 13.5099 11.9304 13.5102 11.9274 13.5106C11.9244 13.5102 11.9305 13.5099 11.9274 13.5099Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3315_16797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassniki);
export default __webpack_public_path__ + "static/media/odnoklassniki.d503fd18942a77e721635d9fd85f171c.svg";
export { ForwardRef as ReactComponent };